module.exports = __webpack_public_path__ + "static/media/new_students_icon.62f5f9e5.svg";